export function triggerEvent(
    target: Element,
    eventName: string,
    options: object = {bubbles: true, cancelable: true, composed: false}
) {
    if (typeof Event === 'function') {
        target.dispatchEvent(new Event(eventName, options));
    }

    // TODO: test this
    if (typeof document['createEventObject'] !== 'undefined') {
        let e = document['createEventObject']();
        e.eventName = eventName;
        e.eventType = eventName;
        target['fireEvent']("on" + e.eventType, e);
    }
}


export function triggerCustomEvent(
    target: Element,
    eventName: string,
    options: object = {bubbles: true, cancelable: true, composed: false, detail: null}
) {
    if (typeof CustomEvent === 'function') {
        target.dispatchEvent(new CustomEvent(eventName, options));
    }

    // TODO: test this
    if (typeof document['createEventObject'] !== 'undefined') {
        let e = document['createEventObject']();
        e.eventName = eventName;
        e.eventType = eventName;
        target['fireEvent']("on" + e.eventType, e);
    }
}
